class AppRouting {
  constructor(appSession, appSessionCapabilities) {
    'ngInject';

    this.appSession = appSession;
    this.appSessionCapabilities = appSessionCapabilities;
  }
  validate(route, authenticationURL = '/login', fallbackURL = '/') {
    const result = {
      allowed: false,
      denied: true,
      redirectTo: '',
    };

    const opts = {
      requiresAuth: true,
      requiresAnonymous: false,
      requiresPermissions: [],
    };

    Object.keys(opts).forEach((name) => {
      if (angular.isDefined(route[name])) {
        opts[name] = route[name];
      }
    });

    if (opts.requiresAnonymous) {
      opts.requiresAuth = false;
      opts.requiresPermissions = [];
    } else if (opts.requiresAuth) {
      opts.requiresAnonymous = false;
    }

    const isAuthenticated = this.appSession.isAuthenticated();
    if (opts.requiresAuth && !isAuthenticated) {
      result.redirectTo = authenticationURL;
    } else if (
      (opts.requiresAnonymous && isAuthenticated) ||
      (
        opts.requiresPermissions &&
        !this.appSessionCapabilities.hasRoutePermissions(opts.requiresPermissions)
      )
    ) {
      result.redirectTo = fallbackURL;
    } else {
      result.allowed = true;
    }

    result.denied = !result.allowed;

    return result;
  }
}

export default AppRouting;
